import { AfterViewInit, Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpProgressEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable, of, concat } from 'rxjs';
import { delay, finalize } from 'rxjs/operators';
import { LoaderService } from '../Services/Loader/loader-service.service';
import { AuthService } from '../Services/AuthService/auth-service.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'app';
  public running: any;
  value=0;
  showSpinner=false;
  private translateAriaObserver?: MutationObserver;
   
   bannerBackground= "";
   countySealImage = "";

  constructor(public router: Router, public loaderService: LoaderService, public _authService: AuthService ) {
    this.bannerBackground = !window.location.origin.includes('https://www')? 
    "https://devnetx.miamidadePA.gov/CDN/"+environment.BannerBackground: `${environment.CDNPath}${environment.BannerBackground}`;
    
    this.countySealImage = !window.location.origin.includes('https://www')? 
    "https://devnetx.miamidadePA.gov/CDN/"+environment.CountySeal: `${environment.CDNPath}${environment.CountySeal}`;
  }

  ngOnInit() {
    var t= "ENV "+environment.CDNPath
    this._authService.isAppOffline()
    this.loaderService.isLoading.subscribe(x =>{
      if(x){
        this.resetProgress()
        this.startProgress(); 
      }
      else{
        this.resetProgress()
      }
    })
  }

  ngAfterViewInit() {
    this.startTranslateAriaSanitizer();
  }

  ngOnDestroy() {
    this.stopProgress();
    if (this.translateAriaObserver) {
      this.translateAriaObserver.disconnect();
      this.translateAriaObserver = undefined;
    }
  }

  private startTranslateAriaSanitizer() {
    if (typeof document === 'undefined') {
      return;
    }

    const sanitize = () => {
      const offendingIds = ['goog-gt-thumbUpButton', 'goog-gt-thumbDownButton'];
      offendingIds.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.hasAttribute('aria-pressed')) {
          el.removeAttribute('aria-pressed');
        }
      });

      // Kendo can emit aria-selected on column headers; this attribute is not valid for columnheader.
      const columnHeaders = document.querySelectorAll('th[role="columnheader"][aria-selected]');
      columnHeaders.forEach((el) => el.removeAttribute('aria-selected'));

      // SiteImprove flags presentational nodes when they remain focusable.
      const presentationalFocusable = document.querySelectorAll('[role="presentation"][tabindex], [role="none"][tabindex]');
      presentationalFocusable.forEach((el) => el.removeAttribute('tabindex'));

      const sortableHelperSpans = document.querySelectorAll('span[aria-label="Sortable"]');
      sortableHelperSpans.forEach((el) => el.removeAttribute('aria-label'));

      const nativeButtonsWithRole = document.querySelectorAll('button[role="button"]');
      nativeButtonsWithRole.forEach((el) => el.removeAttribute('role'));

      const kendoFilterCells = document.querySelectorAll('tr.k-filter-row td[aria-label]');
      kendoFilterCells.forEach((el) => el.removeAttribute('aria-label'));

      const kendoTabPanels = document.querySelectorAll('[role="tabpanel"][aria-expanded]');
      kendoTabPanels.forEach((el) => el.removeAttribute('aria-expanded'));

      const kendoListboxes = document.querySelectorAll('span.k-dropdown-wrap[role="listbox"]');
      kendoListboxes.forEach((el) => {
        el.setAttribute('role', 'combobox');
        el.removeAttribute('aria-readonly');
      });

      const enabledButtons = document.querySelectorAll('button[aria-disabled="false"]:not([disabled])');
      enabledButtons.forEach((btn) => btn.removeAttribute('aria-disabled'));

      // SiteImprove flags aria-disabled on div; strip it from divs regardless of role.
      const divsWithAriaDisabled = document.querySelectorAll('div[aria-disabled]');
      divsWithAriaDisabled.forEach((el) => el.removeAttribute('aria-disabled'));

      // Also remove invalid aria-disabled from generic span elements without a widget role.
      const spansWithAriaDisabled = document.querySelectorAll('span[aria-disabled]');
      spansWithAriaDisabled.forEach((el) => {
        const role = (el.getAttribute('role') || '').toLowerCase();
        if (!role || role === 'none' || role === 'presentation') {
          el.removeAttribute('aria-disabled');
        }
      });

      // Keep hidden Google Translate voting controls out of the accessibility tree.
      const gtHiddenPane = document.getElementById('goog-gt-votingHiddenPane');
      if (gtHiddenPane) {
        gtHiddenPane.setAttribute('aria-hidden', 'true');
      }
      const gtVotingInputs = document.querySelectorAll('#goog-gt-votingForm input');
      gtVotingInputs.forEach((el) => {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      });

      const gtOriginalText = document.getElementById('goog-gt-original-text');
      if (gtOriginalText && !(gtOriginalText.textContent || '').trim()) {
        gtOriginalText.remove();
      }

      const emptySortHelpers = document.querySelectorAll('th .k-link > span:empty, th .k-sort-status:empty');
      emptySortHelpers.forEach((el) => el.remove());

      const emptyNotificationGroups = document.querySelectorAll('.k-notification-group:empty, .k-grid-content .k-height-container > div:empty');
      emptyNotificationGroups.forEach((el) => el.remove());

      const emptyTranslateHelpers = document.querySelectorAll('.VIpgJd-yAWNEb-hvhgNd-k77Iif:empty');
      emptyTranslateHelpers.forEach((el) => el.remove());

      // Add explicit labels to Kendo filter controls rendered at runtime.
      const filterRows = document.querySelectorAll('tr.k-filter-row');
      filterRows.forEach((row) => {
        const cells = Array.from(row.querySelectorAll('td'));
        cells.forEach((cell, index) => {
          if (!cell.getAttribute('role')) {
            cell.setAttribute('role', 'gridcell');
          }

          const headerCell = row.closest('table')?.querySelectorAll('th[role="columnheader"]')?.item(index);
          const headerText = (headerCell?.textContent || '').replace('Sortable', '').trim() || `Column ${index + 1}`;

          const input = cell.querySelector('input:not([type="hidden"])') as HTMLInputElement | null;
          if (input && !input.getAttribute('aria-label')) {
            input.setAttribute('aria-label', `${headerText} filter`);
          }

          const spinButton = cell.querySelector('[role="spinbutton"]') as HTMLElement | null;
          if (spinButton && !spinButton.getAttribute('aria-label')) {
            spinButton.setAttribute('aria-label', `${headerText} date filter`);
          }

          const comboBox = cell.querySelector('[role="combobox"], [role="listbox"]') as HTMLElement | null;
          if (comboBox && !comboBox.getAttribute('aria-label')) {
            comboBox.setAttribute('aria-label', `${headerText} filter options`);
          }
        });
      });
    };

    sanitize();
    this.translateAriaObserver = new MutationObserver(() => sanitize());
    this.translateAriaObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-disabled', 'aria-pressed', 'role']
    });
  }

  public startProgress() {
    this.running = setInterval(() => {
      if (this.value <= 100) {
        this.value++;
      } else {
        this.value = 0;
      }
    }, 30);
  }

  public stopProgress() {
    if (this.running) {
      clearInterval(this.running);
      this.running = null;
    }
  }

  public resetProgress() {
    this.value = 0;
    this.stopProgress();
  }

  public ShowSearch() {
    const url = window.location.href;
    return !(url.includes('/business/'));
  }
}



@Injectable()
export class UploadInterceptor implements HttpInterceptor {
  constructor(public loaderService: LoaderService) { }
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url === 'saveUrl') {
      const events: Observable<HttpEvent<any>>[] = [0, 30, 60, 100].map((x) => of(<HttpProgressEvent>{
        type: HttpEventType.UploadProgress,
        loaded: x,
        total: 100
      }).pipe(delay(1000)));

      const success = of(new HttpResponse({ status: 200 })).pipe(delay(1000));
      events.push(success);

      return concat(...events);
    }

    if (req.url === 'removeUrl') {
        return of(new HttpResponse({ status: 200 }));
    }
    this.loaderService.isLoading.next(this.loaderService.isLoading.value +1);

    return next.handle(req).pipe(
      finalize(
        () => {
          this.loaderService.isLoading.next(this.loaderService.isLoading.value -1);
        }
      )
    );
  }
}
